import { ExtratoDeAntecipacoes } from '../../pkw-data/collect/extrato/extrato-de-antecipacoes.model'
import { ExtratoDeRecebimentos } from '../../pkw-data/collect/extrato/extrato-de-recebimentos.model'
import { ExtratoDeVendas } from '../../pkw-data/collect/extrato/extrato-de-vendas.model'

export class DadosRelatorio {
    vendas: ExtratoDeVendas[]
    recebimentos: ExtratoDeRecebimentos[]
    antecipacoes: ExtratoDeAntecipacoes[]

    constructor(
        vendas: ExtratoDeVendas[],
        recebimentos: ExtratoDeRecebimentos[],
        antecipacoes: ExtratoDeAntecipacoes[]
    ) {
        this.vendas = vendas
        this.recebimentos = recebimentos
        this.antecipacoes = antecipacoes
    }

    possuiVendas() {
        return !!this.vendas && this.vendas.length > 0
    }

    possuiRecebimentos() {
        return !!this.recebimentos && this.recebimentos.length > 0
    }

    possuiAntecipacoes() {
        return !!this.antecipacoes && this.antecipacoes.length > 0
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/relatorio/dados-relatorio.ts